'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherActivity, FeatherBarChart2, FeatherBell, FeatherBook, FeatherBuilding2, FeatherCalendar, FeatherCheckSquare, FeatherChevronsLeft, FeatherChevronsRight, FeatherClock, FeatherCopy, FeatherDollarSign, FeatherFileText, FeatherGitBranch, FeatherInbox, FeatherLogOut, FeatherMessageCircle, FeatherMessageSquare, FeatherMonitor, FeatherPackage, FeatherScale, FeatherTag, FeatherTrendingUp, FeatherUsers } from '@subframe/core';
import { IntegracaoAlertasBadge } from '../IntegracaoAlertasBadge';
import { IntegracaoStatusNavIcon } from '../IntegracaoStatusNavIcon';
import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import React from 'react';
import { SidebarWithCollapsibleSections } from '@/shared/components/ui';
import { useAppSelector } from '@/store/hooks';
import { useNavegacaoProtegida } from '../../contexts/NavegacaoProtegidaContext';
import { painelPermissoesSecretariaHabilitado } from '../../utils/flagPainelPermissoesSecretaria';
import { AdminRoleSwitcher, type AdminRole } from './AdminRoleSwitcher';
type AdminSection = 'administrativo' | 'operacoes' | 'secretaria' | 'atendimento' | 'financeiro' | 'flows' | 'plataforma';
const ROLE_STORAGE_KEY = 'adminGeral.selectedRole';
const DEFAULT_ADMIN_ROLE: AdminRole = 'ADMIN_PLATAFORMA';
const SECTION_VISIBILITY: Record<AdminRole, ReadonlySet<AdminSection>> = {
  ADMIN_PLATAFORMA: new Set(['administrativo', 'operacoes', 'atendimento', 'financeiro', 'plataforma']),
  SECRETARIA: new Set(['secretaria', 'atendimento']),
  DESENVOLVEDOR: new Set(['operacoes', 'flows', 'plataforma'])
};
const isAdminRole = (value: string | null): value is AdminRole => value === 'ADMIN_PLATAFORMA' || value === 'SECRETARIA' || value === 'DESENVOLVEDOR';
interface AdminSidebarProps {
  isMobile?: boolean;
  onNavigate?: () => void;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
  onLogout: () => void;
}
const getNavItemClassName = (isCollapsed: boolean, extraClassName: string = ''): string => {
  const base = isCollapsed ? 'w-full flex-none' : 'h-10 w-full flex-none';
  return extraClassName ? `${extraClassName} ${base}` : base;
};
const getInteractiveProps = (onActivate: () => void): Pick<React.HTMLAttributes<HTMLDivElement>, 'role' | 'tabIndex' | 'onClick' | 'onKeyDown'> => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onActivate();
    }
  };
  return {
    role: 'button',
    tabIndex: 0,
    onClick: onActivate,
    onKeyDown: handleKeyDown
  };
};
export const AdminSidebar: React.FC<AdminSidebarProps> = t0 => {
  const $ = _c(98);
  const {
    isMobile: t1,
    onNavigate,
    isCollapsed: t2,
    onToggleCollapse,
    onLogout
  } = t0;
  const isMobile = t1 === undefined ? false : t1;
  const isCollapsed = t2 === undefined ? false : t2;
  const router = useRouter();
  const navegacaoProtegida = useNavegacaoProtegida();
  const pathname = usePathname();
  const tipoUsuario = useAppSelector(_temp);
  const [selectedRole, setSelectedRole] = React.useState(tipoUsuario === "SECRETARIA" ? "SECRETARIA" : DEFAULT_ADMIN_ROLE);
  let t3;
  let t4;
  if ($[0] !== tipoUsuario) {
    t3 = () => {
      if (tipoUsuario === "SECRETARIA") {
        setSelectedRole("SECRETARIA");
        return;
      }
      const stored = window.localStorage.getItem(ROLE_STORAGE_KEY);
      if (isAdminRole(stored)) {
        setSelectedRole(stored);
      }
    };
    t4 = [tipoUsuario];
    $[0] = tipoUsuario;
    $[1] = t3;
    $[2] = t4;
  } else {
    t3 = $[1];
    t4 = $[2];
  }
  React.useEffect(t3, t4);
  const isSecretaria = tipoUsuario === "SECRETARIA";
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = role => {
      setSelectedRole(role);
      window.localStorage.setItem(ROLE_STORAGE_KEY, role);
    };
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleSelectRole = t5;
  let t6;
  if ($[4] !== selectedRole) {
    t6 = section => SECTION_VISIBILITY[selectedRole].has(section);
    $[4] = selectedRole;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const canSee = t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = painelPermissoesSecretariaHabilitado();
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const painelPermissoesSecretaria = t7;
  const isDesktopCollapsed = !isMobile && isCollapsed;
  let t8;
  if ($[7] !== navegacaoProtegida || $[8] !== onNavigate || $[9] !== router) {
    t8 = path => {
      const seguir = () => {
        router.push(path);
        if (onNavigate) {
          onNavigate();
        }
      };
      if (navegacaoProtegida) {
        navegacaoProtegida.navegar(seguir);
      } else {
        seguir();
      }
    };
    $[7] = navegacaoProtegida;
    $[8] = onNavigate;
    $[9] = router;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const handleNavigate = t8;
  let t9;
  if ($[11] !== navegacaoProtegida || $[12] !== onLogout) {
    t9 = () => {
      if (navegacaoProtegida) {
        navegacaoProtegida.navegar(onLogout);
      } else {
        onLogout();
      }
    };
    $[11] = navegacaoProtegida;
    $[12] = onLogout;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const handleLogout = t9;
  const t10 = isMobile ? "flex" : "hidden lg:flex";
  let t11;
  if ($[14] !== isCollapsed || $[15] !== isMobile || $[16] !== isSecretaria || $[17] !== selectedRole) {
    t11 = !isMobile ? <div className="flex w-full flex-col py-2"><div className="relative flex w-full items-center" style={{
        height: "40px"
      }}><div style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          opacity: isCollapsed ? 1 : 0,
          transform: isCollapsed ? "scale(1)" : "scale(0.7)",
          transition: "opacity 300ms cubic-bezier(0.4, 0, 0.2, 1), transform 300ms cubic-bezier(0.4, 0, 0.2, 1)",
          pointerEvents: isCollapsed ? "auto" : "none"
        }}><Image src="/icone.svg" alt="Arbitralis" width={32} height={32} className="h-8 w-8" /></div><div style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          alignItems: "center",
          gap: "10px",
          opacity: isCollapsed ? 0 : 1,
          transform: isCollapsed ? "translateX(-8px)" : "translateX(0px)",
          transition: "opacity 300ms cubic-bezier(0.4, 0, 0.2, 1), transform 350ms cubic-bezier(0.4, 0, 0.2, 1)",
          pointerEvents: isCollapsed ? "none" : "auto"
        }}><Image src="/Logo.svg" alt="Arbitralis" width={160} height={32} className="h-8 w-auto" /><span className="bg-brand-100 text-brand-700 rounded px-1.5 py-0.5 text-[10px] font-semibold tracking-wider uppercase">Admin</span></div></div>{!isSecretaria ? <div className="w-full pt-3"><AdminRoleSwitcher selected={selectedRole} onSelect={handleSelectRole} isCollapsed={isCollapsed} /></div> : null}</div> : null;
    $[14] = isCollapsed;
    $[15] = isMobile;
    $[16] = isSecretaria;
    $[17] = selectedRole;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isCollapsed || $[20] !== isMobile || $[21] !== onToggleCollapse) {
    t12 = !isMobile && onToggleCollapse && <SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={isCollapsed ? <FeatherChevronsRight /> : <FeatherChevronsLeft />} isCollapsed={isCollapsed} {...getInteractiveProps(onToggleCollapse)}>{isCollapsed ? "Expandir" : "Recolher menu"}</SidebarWithCollapsibleSections.NavItem>;
    $[19] = isCollapsed;
    $[20] = isMobile;
    $[21] = onToggleCollapse;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== isCollapsed) {
    t13 = getNavItemClassName(isCollapsed, "text-error-600 hover:bg-error-50");
    $[23] = isCollapsed;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <FeatherLogOut className="text-error-600" />;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== handleLogout) {
    t15 = getInteractiveProps(handleLogout);
    $[26] = handleLogout;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== isDesktopCollapsed || $[29] !== t13 || $[30] !== t15) {
    t16 = <SidebarWithCollapsibleSections.NavItem className={t13} icon={t14} isCollapsed={isDesktopCollapsed} {...t15}>Sair</SidebarWithCollapsibleSections.NavItem>;
    $[28] = isDesktopCollapsed;
    $[29] = t13;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t12 || $[33] !== t16) {
    t17 = <>{t12}{t16}</>;
    $[32] = t12;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== canSee || $[36] !== handleNavigate || $[37] !== isCollapsed || $[38] !== isDesktopCollapsed || $[39] !== pathname) {
    t18 = canSee("administrativo") && <SidebarWithCollapsibleSections.NavSection label="Administrativo" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBuilding2 />} selected={pathname === "/admin-geral/tenants"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/tenants"))}>Escritórios</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherUsers />} selected={pathname === "/admin-geral/usuarios"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/usuarios"))}>Usuários Globais</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[35] = canSee;
    $[36] = handleNavigate;
    $[37] = isCollapsed;
    $[38] = isDesktopCollapsed;
    $[39] = pathname;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== canSee || $[42] !== handleNavigate || $[43] !== isCollapsed || $[44] !== isDesktopCollapsed || $[45] !== pathname) {
    t19 = canSee("operacoes") && <SidebarWithCollapsibleSections.NavSection label={"Opera\xE7\xF5es"} isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBell />} selected={pathname === "/admin-geral/operacoes/notificacoes"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/operacoes/notificacoes"))}>Notificações Globais</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherMessageSquare />} selected={pathname === "/admin-geral/operacoes/negociacoes"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/operacoes/negociacoes"))}>Negociações Globais</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherScale />} selected={pathname === "/admin-geral/operacoes/arbitragens"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/operacoes/arbitragens"))}>Arbitragens Globais</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[41] = canSee;
    $[42] = handleNavigate;
    $[43] = isCollapsed;
    $[44] = isDesktopCollapsed;
    $[45] = pathname;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== canSee || $[48] !== handleNavigate || $[49] !== isCollapsed || $[50] !== isDesktopCollapsed || $[51] !== pathname || $[52] !== tipoUsuario) {
    t20 = tipoUsuario === "ADMIN" && painelPermissoesSecretaria && !canSee("secretaria") && canSee("administrativo") && <SidebarWithCollapsibleSections.NavSection label="Secretaria" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherUsers />} selected={pathname.startsWith("/admin-geral/secretaria/usuarios-permissoes")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/usuarios-permissoes"))}>Usuários e permissões</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[47] = canSee;
    $[48] = handleNavigate;
    $[49] = isCollapsed;
    $[50] = isDesktopCollapsed;
    $[51] = pathname;
    $[52] = tipoUsuario;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== canSee || $[55] !== handleNavigate || $[56] !== isCollapsed || $[57] !== isDesktopCollapsed || $[58] !== pathname || $[59] !== tipoUsuario) {
    t21 = canSee("secretaria") && <><SidebarWithCollapsibleSections.NavSection label="Secretaria" isCollapsed={isDesktopCollapsed}>{tipoUsuario === "ADMIN" && painelPermissoesSecretaria && <SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherUsers />} selected={pathname.startsWith("/admin-geral/secretaria/usuarios-permissoes")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/usuarios-permissoes"))}>Usuários e permissões</SidebarWithCollapsibleSections.NavItem>}<SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherMonitor />} selected={pathname === "/admin-geral/secretaria"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria"))}>Painel geral</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCheckSquare />} selected={pathname === "/admin-geral/secretaria/triagem"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/triagem"))}>Triagem</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCalendar />} selected={pathname === "/admin-geral/secretaria/prazos"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/prazos"))}>Prazos</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherFileText />} selected={pathname === "/admin-geral/secretaria/processos"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/processos"))}>Processos</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherInbox />} selected={pathname === "/admin-geral/secretaria/ar"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/ar"))}>AR — Acompanhamento</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection><SidebarWithCollapsibleSections.NavSection label={"Configura\xE7\xF5es"} isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherUsers />} selected={pathname.startsWith("/admin-geral/secretaria/arbitros")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/arbitros"))}>Árbitros</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherTag />} selected={pathname.startsWith("/admin-geral/secretaria/situacoes")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/situacoes"))}>Situações</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherGitBranch />} selected={pathname.startsWith("/admin-geral/secretaria/fluxos")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/fluxos"))}>Fluxos</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCopy />} selected={pathname.startsWith("/admin-geral/secretaria/modelos") && !pathname.startsWith("/admin-geral/secretaria/modelos-andamento") && !pathname.startsWith("/admin-geral/secretaria/modelos-comunicacao") && !pathname.startsWith("/admin-geral/secretaria/modelos-carta") && !pathname.startsWith("/admin-geral/secretaria/modelos-notificacao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos"))}>Modelos de documento</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherMessageCircle />} selected={pathname.startsWith("/admin-geral/secretaria/modelos-comunicacao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos-comunicacao"))}>Modelos de comunicação</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBell />} selected={pathname.startsWith("/admin-geral/secretaria/modelos-notificacao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos-notificacao"))}>Modelos de alerta</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherFileText />} selected={pathname.startsWith("/admin-geral/secretaria/modelos-carta")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos-carta"))}>Modelos de carta</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherFileText />} selected={pathname.startsWith("/admin-geral/secretaria/modelos-andamento")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/modelos-andamento"))}>Modelos de andamento</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCalendar />} selected={pathname.startsWith("/admin-geral/secretaria/feriados")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/feriados"))}>Feriados</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherClock />} selected={pathname.startsWith("/admin-geral/secretaria/tipos-prazo")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/secretaria/tipos-prazo"))}>Tipos de prazo</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection></>;
    $[54] = canSee;
    $[55] = handleNavigate;
    $[56] = isCollapsed;
    $[57] = isDesktopCollapsed;
    $[58] = pathname;
    $[59] = tipoUsuario;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] !== canSee || $[62] !== handleNavigate || $[63] !== isCollapsed || $[64] !== isDesktopCollapsed || $[65] !== pathname) {
    t22 = canSee("atendimento") && <SidebarWithCollapsibleSections.NavSection label="Atendimento" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherMessageCircle />} selected={pathname.startsWith("/admin-geral/chat-atendimento")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/chat-atendimento"))}>Chat Atendimento</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBarChart2 />} selected={pathname === "/admin-geral/dashboard-atendimento"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/dashboard-atendimento"))}>Dashboard de atendimento</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[61] = canSee;
    $[62] = handleNavigate;
    $[63] = isCollapsed;
    $[64] = isDesktopCollapsed;
    $[65] = pathname;
    $[66] = t22;
  } else {
    t22 = $[66];
  }
  let t23;
  if ($[67] !== canSee || $[68] !== handleNavigate || $[69] !== isCollapsed || $[70] !== isDesktopCollapsed || $[71] !== pathname) {
    t23 = canSee("financeiro") && <SidebarWithCollapsibleSections.NavSection label="Financeiro" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherDollarSign />} selected={pathname === "/admin-geral/financeiro"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/financeiro"))}>Financeiro</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherPackage />} selected={pathname === "/admin-geral/administrativo/catalogo-produtos"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/administrativo/catalogo-produtos"))}>Catálogo de Produtos</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherClock />} selected={pathname.startsWith("/admin-geral/financeiro/trials")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/financeiro/trials"))}>Trials</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherActivity />} selected={pathname.startsWith("/admin-geral/financeiro/apuracao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/financeiro/apuracao"))}>Apuração de Consumo</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherDollarSign />} selected={pathname.startsWith("/admin-geral/financeiro/faturas")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/financeiro/faturas"))}>Faturas</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[67] = canSee;
    $[68] = handleNavigate;
    $[69] = isCollapsed;
    $[70] = isDesktopCollapsed;
    $[71] = pathname;
    $[72] = t23;
  } else {
    t23 = $[72];
  }
  let t24;
  if ($[73] !== canSee || $[74] !== handleNavigate || $[75] !== isCollapsed || $[76] !== isDesktopCollapsed || $[77] !== pathname) {
    t24 = canSee("flows") && <SidebarWithCollapsibleSections.NavSection label="Flows" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherGitBranch />} selected={pathname === "/admin-geral/flows" || pathname.startsWith("/admin-geral/flows/agents") || pathname.startsWith("/admin-geral/flows/shared") || pathname.startsWith("/admin-geral/flows/simulacao")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/flows"))}>Agentes de Negociação</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherCheckSquare />} selected={pathname.startsWith("/admin-geral/flows/qa")} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/flows/qa"))}>Flows Sandbox</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherBook />} selected={pathname === "/admin-geral/flows/documentacao"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/flows/documentacao"))}>Documentação</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[73] = canSee;
    $[74] = handleNavigate;
    $[75] = isCollapsed;
    $[76] = isDesktopCollapsed;
    $[77] = pathname;
    $[78] = t24;
  } else {
    t24 = $[78];
  }
  let t25;
  if ($[79] !== canSee || $[80] !== handleNavigate || $[81] !== isCollapsed || $[82] !== isDesktopCollapsed || $[83] !== pathname) {
    t25 = canSee("plataforma") && <SidebarWithCollapsibleSections.NavSection label="Plataforma" isCollapsed={isDesktopCollapsed}><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<IntegracaoStatusNavIcon showDot={isDesktopCollapsed} />} rightSlot={!isDesktopCollapsed ? <IntegracaoAlertasBadge /> : null} selected={pathname === "/admin-geral/plataforma/status"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/plataforma/status"))}>Status</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherTrendingUp />} selected={pathname === "/admin-geral/plataforma/logs"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/plataforma/logs"))}>Observabilidade</SidebarWithCollapsibleSections.NavItem><SidebarWithCollapsibleSections.NavItem className={getNavItemClassName(isCollapsed)} icon={<FeatherActivity />} selected={pathname === "/admin-geral/plataforma/porteiro"} isCollapsed={isDesktopCollapsed} {...getInteractiveProps(() => handleNavigate("/admin-geral/plataforma/porteiro"))}>Porteiro de canais</SidebarWithCollapsibleSections.NavItem></SidebarWithCollapsibleSections.NavSection>;
    $[79] = canSee;
    $[80] = handleNavigate;
    $[81] = isCollapsed;
    $[82] = isDesktopCollapsed;
    $[83] = pathname;
    $[84] = t25;
  } else {
    t25 = $[84];
  }
  let t26;
  if ($[85] !== isDesktopCollapsed || $[86] !== t10 || $[87] !== t11 || $[88] !== t17 || $[89] !== t18 || $[90] !== t19 || $[91] !== t20 || $[92] !== t21 || $[93] !== t22 || $[94] !== t23 || $[95] !== t24 || $[96] !== t25) {
    t26 = <SidebarWithCollapsibleSections className={t10} isCollapsed={isDesktopCollapsed} header={t11} footer={t17}>{t18}{t19}{t20}{t21}{t22}{t23}{t24}{t25}</SidebarWithCollapsibleSections>;
    $[85] = isDesktopCollapsed;
    $[86] = t10;
    $[87] = t11;
    $[88] = t17;
    $[89] = t18;
    $[90] = t19;
    $[91] = t20;
    $[92] = t21;
    $[93] = t22;
    $[94] = t23;
    $[95] = t24;
    $[96] = t25;
    $[97] = t26;
  } else {
    t26 = $[97];
  }
  return t26;
};
function _temp(state) {
  return state.auth.user?.tipoUsuario;
}